import _ from "lodash";
import ImageComponent from "../Layouts/ImageComponent";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ShimmerScreen from "../Layouts/ShimmerScreen";
import ModuleSingleCardComponent from "./ModuleSingleCardComponent";
import { useEffect, useState } from "react";
import TitleLogoComponent from "../NewDesign/Misc/TitleLogo/TitleLogoComponent";

const ModuleCardComponent = (props) => {

  const { moduleData, navigateToDetails,
    source, setIsLoading
  } = props;

  const [headerProdData, setHeaderProdData] = useState({})

  useEffect(() => {
    if (!_.isEmpty(moduleData)) {
      console.log('MODULE DATA FOR CARD', moduleData)
      let tags = [];
      let logoURL = ''
      let provider_name = ""
      if (!_.isEmpty(moduleData.provider)) {
        tags.push(moduleData.provider.provider_display_name)
        provider_name = moduleData.provider.provider_display_name;
        logoURL = moduleData.provider.provider_img;

      }
      tags.push('Course')
      if (!_.isEmpty(moduleData.modules)) {
        tags.push(`${moduleData.modules.length} Module${moduleData.modules.length > 1 ? 's' : ''}`)
      }
      if (moduleData.duration) {
        tags.push(`${moduleData.duration}`)
      }
      // tags.push(`${moduleData.views} View${moduleData.views > 1 ? 's' : ''}`)
      let priceInfo = _.cloneDeep(moduleData.priceInfo);
      if(priceInfo!==undefined){
      priceInfo.isAddToCart = moduleData.is_addtocart;}
      setHeaderProdData({
        id: moduleData.course_id,
        title: moduleData.courseName,
        logoURL: logoURL,
        provider_name: provider_name,
        logoAltText: 'CD',
        bannerURL: moduleData.thumbnail,
        tagsArray: tags,
        description: moduleData.coursedescription,
        duration: `${moduleData.duration} ${moduleData.durationUnit}`,
        view: 0,
        price: moduleData.price,
        isPaid: moduleData.isPaid,
        priceInfo: priceInfo
      })
    }
  }, [moduleData])



  return (<>
    <div className="tab-content" id="nav-tabContent">
      <div
        className="tab-pane fade show active"
        id="nav-home"
        role="tabpanel"
        aria-labelledby="nav-home-tab"
      >
        <div className="module-learn-text">
          {
            // moduleData.isLoading ?
            // <div className="mgt30">
            //   <ShimmerScreen
            //   case={'rect'}
            //   width={'100%'}
            //   height={'50px'} />
            //   </div>
            // : <h2 className="mgt30" dangerouslySetInnerHTML={{ __html: moduleData?.courseName }}></h2>
          }
         {false && <div className="d-flex box-meta">
            <div className="img-box-meta">
              <TitleLogoComponent
                logoURL={headerProdData.logoURL}
                altText={""}
                isLoading={moduleData.isLoading}
              />
            </div>
            <div className="meta-lsit">
              {moduleData.isLoading ? <ul className="learncourselistt-row">
                <li><ShimmerScreen case={'rect'} width={'80px'} height={'25px'} /></li>
                <li><ShimmerScreen case={'rect'} width={'80px'} height={'25px'} /></li>
              </ul> : <ul className="learncourselistt-row">

                <li className="text-capitalize">{headerProdData?.provider_name}</li>
                <li>Course</li>
                <li>
                  {moduleData?.modules?.length}{" "}
                  {moduleData?.modules?.length === 1
                    ? "Module"
                    : "Modules"}
                </li>
                <li>
                  {moduleData.duration} {moduleData.durationUnit}
                </li>
                {/* <li>{moduleData.views} View{moduleData.views > 1 ? 's' : ''}</li> */}
              </ul>}
            </div>
          </div>}
          {
          // moduleData.isLoading ? <ShimmerScreen case={'rect'} width={'100%'} height={'80px'} /> :
          //   <p
          //     dangerouslySetInnerHTML={{
          //       __html: moduleData?.coursedescription,
          //     }}
          //   ></p>
            }
          {moduleData?.modules && moduleData?.modules.length > 0
            ? moduleData?.modules?.map((item, index) => {
              return (
                <ModuleSingleCardComponent
                  index={index}
                  item={item}
                  navigateToDetails={navigateToDetails}
                  productData={headerProdData}
                  hasTeaser={moduleData.hasTeaser && index === 0}
                  setIsLoading={setIsLoading}
                />
              );
            })
            : ""}
        </div>
      </div>
      <div
        className="tab-pane fade"
        id="nav-profile"
        role="tabpanel"
        aria-labelledby="nav-profile-tab"
      >
        ...
      </div>
    </div>
  </>)
}
export default ModuleCardComponent;